export default __webpack_public_path__ + "static/media/trbotclap.bd231468.mp3";